import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { BADGE_STATUS_COLORS, BadgePosition, BadgeSize, RaUiBadgeModule } from '@ra-web-tech-ui-toolkit/components';
import { ConfigService, CoreConfiguration } from '@rockwell-automation-inc/service';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-ag-organization-details-renderer',
  standalone: true,
  imports: [CommonModule, RaUiBadgeModule],
  templateUrl: './ag-organization-details-renderer.component.html',
  styleUrl: './ag-organization-details-renderer.component.scss',
})
export class AgOrganizationDetailsRendererComponent implements ICellRendererAngularComp {
  badgeConfig = {
    position: BadgePosition.After,
    color: BADGE_STATUS_COLORS.Status,
    size: BadgeSize.Medium,
  };

  configService = inject<ConfigService<CoreConfiguration>>(ConfigService);
  defaultLogoUrl = `${this.configService.config.csPortalUrl}/tenant-logos/default.png`;

  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  handleImageError(params): boolean {
    params.logoUrlIsNotValid = true;
    return true;
  }
}
